import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './ElephantHunt.css';

const Hunt = createContext(null);
const spots = new Set(['navbar', 'timeline', 'footer', 'terminal']);
export const useElephantHunt = () => useContext(Hunt);

function Elephant() {
    return <svg viewBox="0 0 100 76" aria-hidden="true" focusable="false">
        <path fill="currentColor" d="M13 48C4 45 2 36 5 31L9 33C7 39 11 41 15 41V29C15 9 53 7 65 20C83 9 96 25 91 40L91 55Q91 72 76 68L76 61Q84 63 83 53L81 44L72 48L68 68H56L54 49H39L36 68H23L22 48Z" />
        <path d="M66 24C47 15 46 45 65 43" fill="none" stroke="white" strokeOpacity=".35" strokeWidth="3" />
        <circle cx="81" cy="29" r="2" fill="#171922" />
    </svg>;
}

export function ElephantFind({ id, className = '' }) {
    const { discover } = useElephantHunt();
    return <button type="button" className={`elephant-find ${className}`} aria-label={`Hidden elephant in ${id}`} onClick={() => discover(id)}><Elephant /></button>;
}

export function ElephantHuntProvider({ children }) {
    const found = useRef(new Set());
    const timers = useRef([]);
    const [toast, setToast] = useState(null);
    const [stampede, setStampede] = useState(false);
    useEffect(() => () => timers.current.forEach(clearTimeout), []);
    useEffect(() => {
        if (!stampede) return;
        const stop = event => { if (event.key === 'Escape') setStampede(false); };
        window.addEventListener('keydown', stop);
        return () => window.removeEventListener('keydown', stop);
    }, [stampede]);
    const discover = id => {
        if (!spots.has(id) || found.current.has(id)) return;
        found.current.add(id);
        const count = found.current.size;
        setToast(count);
        clearTimeout(timers.current[0]);
        timers.current[0] = setTimeout(() => setToast(null), 2400);
        if (count === 4) {
            setStampede(true);
            timers.current[1] = setTimeout(() => setStampede(false), 10000);
        }
    };
    return <Hunt.Provider value={{ discover }}>
        <div className={stampede ? 'elephant-world elephant-quake' : 'elephant-world'}>{children}</div>
        {createPortal(<>
            {toast !== null && <div className="elephant-progress" role="status">{toast}/4 found</div>}
            {stampede && <div className="elephant-stampede" aria-hidden="true">
                {Array.from({ length: 64 }, (_, i) => <div className="elephant-runner" key={i} style={{
                    '--lane': `${(i * 17) % 108 - 8}%`, '--size': `${110 + (i * 37) % 240}px`,
                    '--delay': `${(i % 16) * 0.23}s`, '--duration': `${3 + (i % 5) * 0.35}s`,
                    '--elephant-color': ['#8994ab', '#475776', '#bf9a85', '#657b8b', '#b2a0c1'][i % 5]
                }}><div className="elephant-gallop"><Elephant /></div></div>)}
            </div>}
        </>, document.body)}
    </Hunt.Provider>;
}
